export default (value: string, ...args: (string | number)[]): string => {
    let i = 0;
    return value.replace(/{}/g, (): string => {
        // eslint-disable-next-line no-plusplus
        return typeof args[i] !== 'undefined' ? args[i++].toString() : '';
    });
};
